<my-content placeholder="navigation">

    <div class="col-sm-12 " style="border-bottom: 1px solid #ccc;"></div>

    <!-- data-backdrop="static" data-keyboard="false" -->
    <div id="ModalPopUP" class="modal fade" role="dialog">
        <div class="modal-dialog-FactSheet">
            <div class="modal-content">
                <div class="modal-header BlueHeader">
                    <h4 class="Heading"> {{ModelFor}}</h4><br>
                    <button type="button" id="close" class="close" (click)="this[CallFunctionOnCloseModal]()" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body  col-sm-12 form-group">
                    <iframe width="100%" Height="390 px" [src]="modalURL|safe"></iframe>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-12" style="margin-top: 8px;">
        <div class="col-sm-12" style="background-color: #eee; border:1px solid #ddd;padding-top:10px; padding-bottom: 10px;">
            <div class="col-sm-4">
                <!-- <form #SearchPlanDiary="ngForm" [formGroup]="FormSearchPlanDiary" (ngSubmit)="onSearchPlanDiary(SearchPlanDiary.value);"> -->
                <!-- <div class="col-sm-2 height-34">Search</div> -->
                <!-- <div class="col-sm-6"><input class="form-control" formControlName="txtSearch" placeholder="Search here" name="txtSearch" type="text" value=""></div> -->
                <!-- <div class="col-sm-2"><input class="btn btn-primary btn-sm-12" type="submit" value="Go"></div> -->
                <!-- <div class="col-sm-2"> <a title="Advance Search" data-toggle="modal" (click)="OpenModal('ndc','0','Filter','ReturnAdvanceSearch');" data-target="#ModalPopUP"><i _ngcontent-efg-c1="" class="material-icons"> filter_list </i></a>
                    </div> -->

                <!-- </form> -->
            </div>
            <div class="col-sm-4">&nbsp;</div>
            <div class="col-sm-4">
                <div class="col-sm-8">&nbsp;</div>
                <div class="form-group col-sm-4">
                    <a href="#" data-toggle="modal" (click)="OpenModal('evaluationform','0','Add Parameter','GetEvaluationData');" data-target="#ModalPopUP">Add More Parameter</a>
                </div>
                <!--div class="form-group col-sm-6" *ngIf="this.RightsID.includes('202024001') || this.RightsID.includes('202024021') ; then ADDDiaryLink else ADDDiaryNotLink"></!--div>
                  <ng-template #ADDDiaryLink>
                    <a href="#" data-toggle="modal" (click)="OpenModal('evaluationform','0','Add Parameter','ReturnAdvanceSearch');" data-target="#ModalPopUP">Add More Parameter</a>
                  </ng-template>
                  <ng-template-- #ADDDiaryNotLink>
                      <a href="module/0">Add Parameter</a>
                  </ng-template-->


                <!-- <div class="col-sm-4 height-34">&nbsp;
                  <a href="#/report/207040000" data-toggle="modal">Diary Listing</a>
              </div> -->
            </div>
        </div>
    </div>
    <div class="col-sm-12" style="margin-top: 8px;"></div>
    <div class=" col-sm-12">
        <div class=" col-sm-12 lefticonD paddingless tableHeading">Evaluation Parameter</div>
        <table width="100%" class="LMtable">
            <tr>
                <th>S.No.</th>
                <!-- <th>Parameter For</th> -->
                <th>Caption</th>
                <th>Parameter Type</th>
                <!-- <th>Value</th> -->
                <th>Sequence No</th>
                <th>For Decision</th>
                <th>For Notice</th>
                <th>For Case</th>
                <th>Action</th>
            </tr>

            <!-- ============== Show Message / Loading ============== -->
            <tr *ngIf="this.MsgType == 1">
                <td colspan="80">
                    <div class="d-flex align-items-center">
                        <strong>Loading&nbsp;&nbsp;&nbsp;</strong>
                        <div class="spinner-border" role="status"></div>
                    </div>
                </td>
            </tr>
            <tr *ngIf="this.MsgType == 2">
                <td colspan="80">&nbsp;<span class="glyphicon glyphicon-info-sign"></span>&nbsp;
                    <span>{{DisplayMessage}}</span>
                </td>
            </tr>
            <tr *ngIf="this.MsgType == 3">
                <td colspan="80"><span class="Err">{{DisplayMessage}}</span>
                </td>
            </tr>
            <!-- ==================================================== -->

            <tr *ngFor="let evaluation of Evaluation | paginate: { itemsPerPage: 10, currentPage: pageNumber }; let i=index ">
                <td>{{(pageNumber - 1) * 10 + i +1 }}</td>
                <!-- <td> {{evaluation.FormName}} </td> -->
                <td> {{evaluation.Caption}} </td>
                <td> {{evaluation.ParameterType}} </td>
                <!-- <td *ngIf="evaluation.ParameterType == 'DropDown Single Selection' || evaluation.ParameterType=='Dropdown Multiple Selection'">
                    {{evaluation.Value}}
                </td>
                <td *ngIf="evaluation.ParameterType != 'DropDown Single Selection' && evaluation.ParameterType!='Dropdown Multiple Selection'">
                    {{evaluation.DefaultValue}}
                </td> -->
                <td> {{evaluation.Position}} </td>

                <td>{{evaluation.IsDecisionValue}}</td>
                <td>{{evaluation.IsNoticeValue}}</td>
                <td>{{evaluation.IsCaseValue}}</td>
                <td *ngIf="evaluation.id >= 900">
                   &nbsp;
                </td>
                <td *ngIf="evaluation.id <= 900">
                    <a href="#" data-toggle="modal" (click)="OpenModal('evaluationform',evaluation.id,'Add Parameter','GetEvaluationData');" data-target="#ModalPopUP"><img src="assets/resources/images/edit.png"></a>
                </td>

            </tr>
        </table><br>

        <pagination-controls (pageChange)="pageNumber = $event"></pagination-controls>
    </div>


    <div><br></div>

</my-content>
<my-content placeholder="main">

</my-content>
